interface VerifyAccessResponse {
  message: string;
  roles?: string[];
  scopes?: string[];
}

async function verifyAccess(jwtToken: string, baseUrl: string, roles?: string[], scopes?: string[]): Promise<VerifyAccessResponse> {
  try {
    const response = await fetch(baseUrl + 'verify', {
      method: 'POST',
      headers: {
        'jwt-token': jwtToken,
      },
    });

    const json: VerifyAccessResponse = await response.json();
    console.log(json);
    return json;
  } catch (error) {
    console.error('Error verifying access:', error);
    return {
      message: "unsuccessful"
    };
  }
}

export default verifyAccess;
